export const transferOrderStatus = [
  { value: 1, label: '待完善' },
  { value: 2, label: '待支付' },
  { value: 3, label: '已支付' },
  { value: 4, label: '待接单' },
  { value: 5, label: '审核中' },
  { value: 6, label: '审核失败' },
  { value: 7, label: '审核成功' },
  { value: 8, label: '待邮寄' },
  { value: 9, label: '已邮寄' },
  { value: 10, label: '操作中' },
  { value: 11, label: '需补寄资料' },
  { value: 12, label: '已出签' },
  { value: 13, label: '已收货' },
  { value: 14, label: '订单有误' },
  { value: 15, label: '申请退款' },
  { value: 16, label: '退款中' },
  { value: 17, label: '已退款' },
  { value: 18, label: '资料已补充' },
]
// export const transferOrderSubStatus = [
//   { value: 1, label: '待完善' },
//   { value: 2, label: '待支付' },
//   { value: 3, label: '已支付' },
//   { value: 4, label: '待接单' },
//   { value: 5, label: '审核中' },
//   { value: 6, label: '审核失败' },
//   { value: 7, label: '审核成功' },
//   { value: 8, label: '待邮寄' },
//   { value: 9, label: '已邮寄' },
//   { value: 10, label: '操作中' },
//   { value: 11, label: '需补寄资料' },
//   { value: 12, label: '已完成' },
//   { value: 13, label: '申请退款' },
//   { value: 14, label: '退款中' },
//   { value: 15, label: '已退款' },
//   { value: 18, label: '资料已补充' },
// ]
export const transferOrderSubStatus = [
  { value: 10, label: '待支付' },
  { value: 20, label: '签证审核待接单' },
  { value: 30, label: '签证审核处理中' },
  { value: 35, label: '增项待补款' },
  { value: 40, label: '签证操作待接单' },
  { value: 50, label: '签证操作处理中' },
  { value: 60, label: '已发货' },
  { value: 70, label: '已完成' },
  { value: 80, label: '已取消' },
  { value: 90, label: '退款中' },
]

export const visaOrderStatus = [
  { value: 1, label: '待完善' },
  { value: 2, label: '待提交' },
  { value: 5, label: '待支付' },
  { value: 6, label: '支付中' },
  { value: 7, label: '待出签' },
  { value: 8, label: '已出签' },
  { value: 9, label: '资料有误' },
  { value: 10, label: '已拒签' },
  { value: 11, label: '已收货' },
  { value: 12, label: '订单有误' },
  { value: 15, label: '处理中' },
  { value: 16, label: '材料已完成' },
  { value: 17, label: '已退款' },
  { value: 20, label: '已完善' },
  { value: 21, label: '日本电子签证申请中' },
  { value: 22, label: '日本电子签证待缴费' },
  { value: 23, label: '日本电子签证已出结果' },
  { value: 24, label: '提交失败' },
  { value: 25, label: '提交中' },
  { value: 26, label: '提交成功' },
  { value: 27, label: '正在支付中' },
  { value: 28, label: '新加坡提交排队中' },
  { value: 29, label: '新加坡支付排队中' },
  { value: 30, label: '面试预约成功' },
]
export const visaOrderSubStatus = [
  { value: 1, label: '待完善' },
  { value: 2, label: '待提交' },
  { value: 5, label: '待支付' },
  { value: 6, label: '支付中' },
  { value: 7, label: '待出签' },
  { value: 8, label: '已出签' },
  { value: 9, label: '资料有误' },
  { value: 10, label: '已拒签' },
  { value: 11, label: '已收货' },
  { value: 12, label: '订单有误' },
  { value: 15, label: '处理中' },
  { value: 16, label: '材料已完成' },
  { value: 17, label: '已退款' },
  { value: 20, label: '已完善' },
  { value: 21, label: '日本电子签证申请中' },
  { value: 22, label: '日本电子签证待缴费' },
  { value: 23, label: '日本电子签证已出结果' },
  { value: 24, label: '提交失败' },
  { value: 25, label: '提交中' },
  { value: 26, label: '提交成功' },
  { value: 27, label: '正在支付中' },
  { value: 28, label: '新加坡提交排队中' },
  { value: 29, label: '新加坡支付排队中' },
  { value: 30, label: '面试预约成功' },
]
export const orderChannel = [
  { value: 0, label: '同业旅行社' },
  { value: 1, label: '穷游订单' },
  { value: 2, label: '飞猪订单' },
]
export const orderType = [
  { value: 0, label: '旅游签证' },
  { value: 1, label: '商务签证' },
  { value: 2, label: '探亲签证' },
  { value: 3, label: '留学签证' },
  { value: 4, label: '移民签证' },
  { value: 5, label: '其他' },
]
export const sex = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
]
export const productType = [{ value: 1, label: '公证' }]

export const authentcationType = [
  { value: 2, label: '单认证' },
  { value: 3, label: '双认证' },
]
export const companyType = [
  { value: 1, label: '旅行社' },
  { value: 2, label: '供应商' },
]
export const orderBranch = [
  { value: 0, label: '未分账' },
  { value: 1, label: '分账中' },
  { value: 2, label: '已分账' },
]
export const orderEmergentStatus = [
  { value: 0, label: '未分账' },
  { value: 1, label: '分账中' },
  { value: 2, label: '已分账' },
]
export const notarOrderStatus = [
  { value: 1, label: '待完善' },
  { value: 2, label: '待支付' },
  { value: 3, label: '已支付' },
  { value: 4, label: '待接单' },
  { value: 5, label: '操作中' },
  { value: 6, label: '需补寄/资料有误' },
  { value: 7, label: '已完成' },
  { value: 8, label: '已收货' },
  { value: 9, label: '订单有误' },
  { value: 10, label: '申请退款' },
  { value: 11, label: '退款中' },
  { value: 12, label: '已退款' },
  { value: 13, label: '待补款' },
  { value: 14, label: '资料已补充' },
  { value: 40, label: '已取消' },
  { value: 80, label: '认证待接单' },
  { value: 81, label: '认证操作中' },
  { value: 82, label: '认证资料有误' },
  { value: 83, label: '认证资料已补充' },
  { value: 84, label: '认证待补款' },
]
